<template>
  <div>
    <div class="card">
      <a-table :columns="columns" :data-source="data.users" :pagination="false">
        <a slot="fullname" slot-scope="user"
          >{{ user.firstname }} {{ user.lastname }}</a
        >

        <a slot="admin" slot-scope="user"
          ><a-tag color="green">{{
            user.manage_faculty ? "แดชบอร์ดหน่วยงานตนเอง" : ""
          }}</a-tag></a
        >

        <a-button
          @click="revoke(user.id)"
          type="danger"
          v-if="user.manage_faculty"
          slot="manage"
          slot-scope="user"
        >
          ยกเลิกสิทธิ์
        </a-button>

        <a-button
          @click="grant(user.id)"
          v-else
          slot="manage"
          slot-scope="user"
        >
          ให้สิทธิ์
        </a-button>
      </a-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";

const columns = [
  {
    title: "ชื่อ - สกุล",
    scopedSlots: { customRender: "fullname" },
  },
  {
    title: "สิทธิ์การเข้าถึง",
    scopedSlots: { customRender: "admin" },
  },
  {
    title: "จัดการ",
    scopedSlots: { customRender: "manage" },
  },
];

export default {
  created() {
    this.fetchFaculty();
  },
  data() {
    return {
      data: {},
      columns,
    };
  },
  methods: {
    async fetchFaculty() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/faculty/${this.$route.params.facultyId}`,
      });

      this.data = response.data;
    },

    async grant(userId) {
      const facultyId = this.data.faculty.id;

      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/faculty-admin/grant`,
        data: { facultyId, userId },
      });
      this.$router.go();
    },
    async revoke(userId) {
      const facultyId = this.data.faculty.id;

      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/faculty-admin/revoke`,
        data: { facultyId, userId },
      });
      this.$router.go();
    },
  },
};
</script>